<template>
	<div>
		<!-- Headline -->
		<div slot="headline" class="fs5 lh125 fw7 c1 mb2">
			{{ $t("clauses") }}
		</div>

		<!-- Empty -->
		<j-card
			v-if="!clauses || clauses.length === 0"
			class="bg5 p3 fs3 flex xs-center"
		>
			{{ $t("errors.no_data") }}
		</j-card>

		<!-- List of selected clauses -->
		<div v-else class="clause-list bg4">
			<j-card
				v-for="(clause, i) in clauses"
				:key="i"
				class="flex xs-12 xs-column bg5 p2 mb2"
			>
				<!-- Top -->
				<div class="flex xs-12 xs-column mb2">
					<!-- Name -->
					<div class="flex xs-middle mb2">
						<p class="mr1 fs3 c6">{{ `${$t("name")}:` }}</p>
						<p class="fs3">{{ clause.template.name }}</p>
					</div>
					<!-- renderedHtmlResult -->
					<div class="flex xs-column">
						<p class="mr1 fs3 mb1 c6">{{ `${$t("description")}:` }}</p>
						<div
							class="fs3 lh150"
							v-html="clause.renderedHtmlResult.value"
						></div>
					</div>
				</div>
			</j-card>
		</div>
	</div>
</template>

<script>
// HACK: This component is hacked
// It is fetching clauses from offer instead of policy because there is a bug on policy.clauses in APIs
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"

// HACK: we are using api in different module than caseManagement
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	props: {
		policyId: {
			type: String
		}
	},

	components: {
		JCard,
		CrmIcon,
		JButton
	},

	data() {
		return {
			clauses: []
		}
	},

	methods: {
		async fetchClausesForOffer() {
			const query = gql`
				query clauses($where: policyWhereInput) {
					policies(where: $where) {
						list {
							id
							clauses {
								id
								template {
									id
									name
									graphQlQuery
									... on clauseHtml {
										html
									}
								}
								renderedHtmlResult {
									value
								}
								renderParameters {
									contentJsonString
									variablesJsonString
								}
							}
						}
					}
				}
			`

			const variables = { where: { id: this.policyId } }
			const res = await api({ query, variables })

			// HACK: take only the first offer from basket as we don't have offerId at our disposal
			// this.clauses = res?.data?.policies?.list?.[0]?.proposal?.basket?.[0]?.clauses?.reverse()
			this.clauses = res?.data?.policies?.list?.[0]?.clauses?.reverse()
		}
	},

	async created() {
		await this.fetchClausesForOffer()
	}
}
</script>

<style scoped>
.clause-list {
	max-height: 300px;
	overflow: scroll;
}
</style>
